import { call, put, select, takeEvery } from 'redux-saga/effects';

import { types as uiTypes } from '@elab/core/store/ui';
import { getComponentsByIds } from '@elab/core/store/global/api';
import { selectors as userSelectors } from '@elab/core/store/user';
import { actions as analyticsActions } from '@elab/core/store/analytics';

import api from './api';
import types from './types';
import actions from './actions';
import { constants as modes } from './constants';

function orderModelFaces(faces = []) {
    if (!faces.length) {
        return [];
    }
    let order = (faces[0].component.medias || '').split(' ');
    return faces.reduce((acc, face) => {
        acc[order.indexOf(face.uid)] = face;
        return acc;
    }, []);
}

function normalizeModifaceData({ products = [] }) {
    return products.reduce((acc, product) => {
        try {
            acc.push({
                ...product,
                shadeArray: JSON.parse(product.shadeArray),
            });
        } catch (e) {
            /* Skip product */
        }
        return acc;
    }, []);
}

function* watchInitFaceChoice({ payload }) {
    if (!payload.modelIds) {
        return;
    }

    try {
        const userId = yield select(userSelectors.getUserId);
        const data = yield call(getComponentsByIds, payload.modelIds, userId);
        if (data.component) {
            yield put(actions.setFaces(orderModelFaces(data.component)));
        }
    } catch (e) {
        yield put(actions.modifaceError(e.message));
    }
}

function* watchGetMakeupProductData({ payload: productCode }) {
    try {
        const makeupData = yield call(api.getMakeupProductData, productCode);
        const normalizedData = normalizeModifaceData(makeupData || {});
        yield put(actions.setMakeupProductData(normalizedData));
        const currentProductIdx = normalizedData.findIndex(product => product.code === productCode);
        yield put(actions.setCurrentShade(currentProductIdx));
    } catch (e) {
        yield put(actions.modifaceError(e.message));
    }
}

function* watchStartModiface({ payload }) {
    try {
        if (payload.mode === modes.LIVE_MODE || payload.mode === modes.PHOTO_MODE) {
            yield put(
                analyticsActions.handleChooseModifaceMode({
                    mode: payload.mode,
                    productCode: payload.productCode,
                }),
            );
        }
    } catch (error) {
        console.log(error);
    }
}

function* watchPopupClose() {
    yield put(actions.resetModifaceError());
    yield put(actions.startMode({ mode: modes.CHOICE_MODE }));
}

function* watchLibraryError({ payload }) {
    if (payload && payload.includes('ERROR_WEBCAM')) {
        yield put(analyticsActions.handleCameraError({ value: false }));
    }
    yield put(actions.startMode({ mode: modes.CHOICE_MODE }));
    yield put(actions.modifaceError());
}

export default [
    takeEvery(types.INIT_FACE_CHOICE, watchInitFaceChoice),
    takeEvery(types.SET_LIBRARY_INITIALIZED, watchGetMakeupProductData),
    takeEvery(types.START_MODE, watchStartModiface),
    takeEvery(uiTypes.CLOSE_LIGHT_POPUP, watchPopupClose),
    takeEvery(types.LIBRARY_ERROR, watchLibraryError),
];
